import { useMemo } from 'react';
import styled from 'styled-components';
import { VisuallyHidden } from '../visually_hidden';

const StyledContainer = styled.div`
	display: flex;
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	white-space: pre;

	.cellula-attachment__filename-start {
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
`;

interface AttachmentFileNameProps {
	children: string;
}

export function AttachmentFileName({ children: name }: AttachmentFileNameProps): JSX.Element {
	const [start, end] = useMemo(() => {
		// We want the CSS ellipsis to look like, given the value
		// "abcdefghijklmnopqrstuvwx.jpg", "abc... yz.jpg" instead of "abc....jpg" so
		// we split the name 6 from the end.
		const splitIndex = name.length > 6 ? 6 : 0;
		const start = name.slice(0, name.length - splitIndex);
		const end = splitIndex !== 0 ? name.slice(-splitIndex) : null;

		return [start, end];
	}, [name]);

	return (
		<StyledContainer>
			<span className='cellula-attachment__filename-start' aria-hidden>
				{start}
			</span>
			<span aria-hidden>{end}</span>
			<VisuallyHidden>{name}</VisuallyHidden>
		</StyledContainer>
	);
}
